import { render, staticRenderFns } from "./CalculateShipping.vue?vue&type=template&id=c6133a56"
import script from "./CalculateShipping.vue?vue&type=script&lang=js"
export * from "./CalculateShipping.vue?vue&type=script&lang=js"
import style0 from "./CalculateShipping.vue?vue&type=style&index=0&id=c6133a56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports